import { render, staticRenderFns } from "./nhan-su-cho-duyet.vue?vue&type=template&id=f0cb5e66"
import script from "./nhan-su-cho-duyet.vue?vue&type=script&lang=js"
export * from "./nhan-su-cho-duyet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports